import React, { useState } from 'react';
import { formatCurrency } from '../../lib/utils';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Smartphone, AlertTriangle, ShieldAlert } from 'lucide-react';

export const groupServicesByCup = (services) => {
  const groups = {};
  services.forEach((s) => {
    const key = s.cup_amount || s.name;
    (groups[key] = groups[key] || []).push(s);
  });
  return Object.values(groups);
};

export const ServiceGroupCard = ({ group, user, apiActive, calculatePrice, onRecharge }) => {
  const [selectedId, setSelectedId] = useState(group[0].id);
  const service = group.find((s) => s.id === selectedId) || group[0];
  const finalPrice = calculatePrice(service.base_price);
  const canAfford = user?.balance >= finalPrice;
  const canRecharge = canAfford && apiActive;
  const discount = user?.discount_percentage || 0;

  return (
    <Card
      className={`bg-card border-border/40 transition-all hover:border-primary/50 ${!canRecharge ? 'opacity-60' : ''}`}
      data-testid={`service-group-${service.cup_amount}`}
    >
      <CardContent className="p-5">
        <div className="space-y-3">
          <div className="flex justify-between items-start gap-2">
            <div>
              <p className="font-bold text-lg">{service.name}</p>
              {group.length === 1 && <p className="text-xs text-muted-foreground">{service.description}</p>}
            </div>
            <Badge variant="secondary" className="font-mono shrink-0">{service.cup_amount} CUP</Badge>
          </div>
          {group.length > 1 && (
            <Select value={selectedId} onValueChange={setSelectedId}>
              <SelectTrigger className="bg-secondary/50 text-xs h-auto min-h-9 text-left" data-testid={`service-option-select-${service.cup_amount}`}>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {group.map((opt) => (
                  <SelectItem key={opt.id} value={opt.id} data-testid={`service-option-${opt.id}`}>
                    <span className="text-xs">{formatCurrency(calculatePrice(opt.base_price))} — {opt.description}</span>
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          )}
          <div className="space-y-1">
            {discount !== 0 && (
              <p className="text-sm text-muted-foreground line-through">{formatCurrency(service.base_price)}</p>
            )}
            <p className="text-2xl font-black text-accent">{formatCurrency(finalPrice)}</p>
            {discount !== 0 && (
              <p className="text-xs text-primary">
                {discount > 0
                  ? `Ahorras ${formatCurrency(service.base_price - finalPrice)} (${discount}%)`
                  : `Recargo ${formatCurrency(finalPrice - service.base_price)} (+${Math.abs(discount)}%)`}
              </p>
            )}
          </div>
          <Button
            className="w-full btn-glow"
            disabled={!canRecharge}
            onClick={() => onRecharge(service)}
            data-testid={`recharge-btn-${service.id}`}
          >
            {!apiActive ? (
              <><ShieldAlert className="w-4 h-4 mr-2" />API Desactivada</>
            ) : canAfford ? (
              <><Smartphone className="w-4 h-4 mr-2" />Recargar</>
            ) : (
              <><AlertTriangle className="w-4 h-4 mr-2" />Saldo Insuficiente</>
            )}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
